import {useQuery, UseQueryResult} from '@tanstack/react-query';
import ProblemDetailsError from '../ProblemDetailsError.ts';
import {useCreateAuthenticatedFetch} from '../useCreateAuthenticatedFetch.ts';
import baseUrl from '../baseUrl.ts';
import {handleResponse} from '../handleResponse.ts';

export const useGetPendingCertificationsCount = (
    isAuthenticated: boolean,
    isAdmin: boolean
): UseQueryResult<number, Error | ProblemDetailsError> => {
    const authenticatedFetch = useCreateAuthenticatedFetch();

    return useQuery({
        queryKey: ['pending-certifications-count', isAuthenticated, isAdmin],
        queryFn: async () => {
            const response = await authenticatedFetch(
                `${baseUrl}/api/admin/pending-certifications-count`
            );
            return handleResponse(response);
        },
        enabled: isAuthenticated && isAdmin,
        refetchInterval: 15 * 60 * 1000
    });
};
